import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { AiFillShop, AiFillCreditCard, AiFillBank } from 'react-icons/ai';
import InputLabel from '@mui/material/InputLabel';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import toast, { Toaster } from 'react-hot-toast';
import { FiLoader } from "react-icons/fi";
import full from './full_logo.png';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
export const config = {
  Accept: 'application/json',
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};

const Webpage = () => {
  const { cid } = useParams();
  const [amount, setAmount] = useState();
  const [product, setProduct] = useState('');
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [address, setAddress] = useState([]);
  const [isPaid, setIsPaid] = useState(false);
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [Name, setName] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [payoutsEnabled, setPayoutsEnabled] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const [paymentType, setPaymentType] = useState('ACH');

  useEffect(() => {
    handleStripeAccount();
  },[]);

  const handlegetCompanyName = async () => {
    const response = await axios.get(`${baseURL}/company/unauthenticated-get-company/${cid}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      }
    })
    setCompanyName(response?.data?.data?.entity?.name);
    setCompanyLogo(response?.data?.data?.entity?.profile_photo_url);
    setAddress(response?.data?.data?.entity?.address_data);
    setLoading(false);
  }
  const handleStripeAccount = async () => {
    const res = await axios.get(`${baseURL}/payment/account/${cid}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      }
    })
    setPayoutsEnabled(res?.data?.data?.entity?.payouts_enabled);
    setAccountId(res?.data?.data?.entity?.id);
    handlegetCompanyName()
  }

  const handleInvoice = async () => {
    const element = document.getElementById('payment-receipt');

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none'; // Hide the iframe

    // Append the iframe to the document
    document.body.appendChild(iframe);

    // Access the iframe's document and write the HTML content
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write('<html><head><title>Print</title>');
    iframeDoc.write('<script src="https://cdn.tailwindcss.com"></script>');
    iframeDoc.write('</head><body>');
    iframeDoc.write(element.innerHTML);
    iframeDoc.write('</body></html>');
    iframeDoc.close();

    // Wait for the iframe to load
    iframe.onload = () => {
      // Print the content inside the iframe
      iframe.contentWindow.print();
    };
  };
  const validateEmail = (email1) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email1);
  };
  const handlePay = async () => {
    if (isValidEmail == false) {
      toast.error('Enter a vaild Email');
      return;
    }
    if (email.length < 2 && isValidEmail == true) {
      toast.error('Enter a vaild Email');
      return;
    }
    if (Number(amount) > 1000000 || Number(amount) < 0.35) {
      toast.error('Amount should be less than $1M and more than $0.35');
      return;
    }
    if (product.length < 1) {
      toast.error('Enter detail');
      return;
    }
    if (number?.length !== 10 & number !== '') {
      toast.error('Enter valid number');
      return;
    }
    setLoading1(true);
    const checkoutFormDataCharge = {
      contact_id: null,
      product_name: product,
      amount: Number(amount),
      name: Name?.length ? Name : null,
      phone: number?.length ? number : null,
      email: email,
      surcharge: (cid === 'c07d4186-75ce-41de-a770-98f74469633f' ? (Number(amount) * 0.030) : (paymentType === 'card' ? (Number(amount) * 0.030) : 0)),
      payment_method_type: 'payment_checkout',
      payment_method: (cid === 'c07d4186-75ce-41de-a770-98f74469633f' ? 'card' : paymentType),
      company_id: cid,
    };
    const res = await axios.post(`${baseURL}/payment/create-charge-card/${accountId}`,checkoutFormDataCharge, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      }
    })
    window.open(res.data);
    setTimeout(() => {
      window.location.reload();
    },[5000])
  };

  const handleChange = (event) => {
    const newEmail = event.target.value;
    setEmail(newEmail);
    setIsValidEmail(validateEmail(newEmail));
  };
  const useStyles = makeStyles({
    myTextfield: {
        
      '& .MuiInputBase-input': {
        color: 'black',
        borderBottom: '1px solid #E9E3FE',
        fontSize: '14px',
        transition: 'border-color 0.3s ease',
      },
      '& .MuiInputBase-input:focus': {
        borderColor: '#3074DC',
        borderBottom: '2px solid #3074DC',
        outline: 'none',
      },
      '& .MuiFormLabel-root': {
        paddingLeft: '5px',
        fontSize: '14px',
      },
    },
    otpTextfield: {
      '& .MuiInputBase-input': {
        color: 'black',
        border: '2px solid #eee',
        borderRadius: '5px',
        padding: '5px',
        transition: 'border-color 0.3s ease',
      },
      '& .MuiInputBase-input:focus': {
        borderColor: 'blue',
        outline: 'none',
      },
    },
    helperText: {
      /* Add your custom styles for the helper text here */
      color: 'red',
      fontSize: '5px',
      marginTop: '4px',
    },

  });
  const classes = useStyles();
  const [formattedAmount, setFormattedAmount] = useState('');

    const handleAmountChange = (e) => {
        const input = e.target.value;
        // Remove any non-numeric characters
        const numericInput = input.replace(/[^0-9.]/g, '');
        // Ensure there's only one decimal point
        const sanitizedInput = numericInput.replace(/(\..*)\./g, '$1');
        // Limit to two decimal places
        const roundedInput = sanitizedInput.replace(/(\.[0-9]{2})[0-9]*/g, '$1');
        setAmount(roundedInput);

        // Format the amount for display
        const formatted = `$ ${roundedInput}`; // Add dollar sign and space
        setFormattedAmount(formatted);
    };
  

  if (loading) {
    return (
      <div className="w-full h-[100vh] items-center justify-between flex flex-col">
        <FiLoader size={50} className="animate-spin mt-[47vh]" />
        <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>

          <span className="text-[#535355]"> Powered by</span>
          <div
            className='flex items-center ml-1 cursor-pointer'
            onClick={() => window.open('https://www.salescaptain.com')}
          >
            <img src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png" className=" h-[18px]" alt="" />
            <span
              className="font-semibold ml-1"
            >
              SalesCaptain
            </span>
          </div>
        </div>

      </div>
    );
  }

  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center" id="payment-receipt">
      <div className="flex gap-3 items-center  text-[#1a1a1ab3] medium text-[15px]">
        {companyLogo && (
          <span className="text-[#1a1a1ab3] medium text-[15px] bg-white  
          p-1 w-[60px] h-[60px] rounded-md object-fill"
          >
            {' '}
            <img className="w-full h-full" src={companyLogo} alt="" />

          </span>
        )}
        <div className="flex flex-col gap-1">
          <span className="text-[#3975cb]  medium text-[18px] tracking-wide">{companyName}</span>
          <span className="regular text-[10px] tracking-wide">
            {address?.street_address}
            {' '}
            {address?.apartment_or_suite}
            {' '}
            {address?.city}
            {' '}
            {address?.zip}
          </span>
        </div>
        {/* <div className='flex pl-5'>
          <button onClick={handleInvoice} className='flex w-full justify-center border shadow-md p-3 rounded-xl'>Download</button>
        </div> */}
      </div>
      <div className="space-y-2 text-gray-500 shadow-xl flex flex-col rounded-[25px] border-[1px] border-[#E2E8F0] p-3 px-7 w-[380px] mt-5">
        <div className="flex items-center justify-between  ">
          <div className=" medium text-[16px] py-2">
            Enter payment details
          </div>
        </div>
        <div className="flex flex-col items-center justify-between py-1.5 ">
          <TextField
                id="outlined-basic" 
                variant="outlined"
                className={classes.myTextfield}
                sx={{ width: '100%', paddingLeft: '5px' }}
                value={formattedAmount}
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                label='Amount to be Paid(USD)*'
                onChange={(e) => {
                  handleAmountChange(e);
                }}
                size="small"
            />
        </div>
        <div className="flex flex-col items-center justify-between py-1.5">
            <TextField
                id="outlined-basic" 
                variant="outlined"
                className={classes.myTextfield}
                sx={{ width: '100%', paddingLeft: '5px' }}
                onKeyUp={(e) => validateEmail(e)}
                error={!isValidEmail}
                placeholder="username@gmail.com"
                value={email}
                label='Email*'
                onChange={handleChange}
                size="small"
            />
        </div>
        <div className="flex flex-col items-center justify-between py-1.5 ">
          <TextField
                id="outlined-basic" 
                variant="outlined"
                className={classes.myTextfield}
                sx={{ width: '100%', paddingLeft: '5px' }}
                value={product}
                label='Detail*'
                onChange={(e) => setProduct(e.target.value)}
                size="small"
            />
        </div>
        <div className="flex flex-col items-center justify-between py-1.5 ">
          <TextField
                id="outlined-basic" 
                variant="outlined"
                className={classes.myTextfield}
                sx={{ width: '100%', paddingLeft: '5px' }}
                value={Name}
                label='Name'
                onChange={(e) => setName(e.target.value)}
                size="small"
            />
        </div>
        <div className="flex flex-col items-center justify-between py-1.5 ">
          <TextField
                id="outlined-basic" 
                variant="outlined"
                className={classes.myTextfield}
                sx={{ width: '100%', paddingLeft: '5px' }}
                value={number}
                label='Number'
                onChange={(e) => {
                  const input = e.target.value;
                  const numericInput = input.replace(/[^0-9]/g, '');
                  const limitedInput = numericInput.slice(0, 10);
                  setNumber(limitedInput);
                }}
                size="small"
            />
        </div>
        {cid !== 'c07d4186-75ce-41de-a770-98f74469633f' && (
          <label htmlFor="email" className="text-[#1a1a1ab3] medium w-[200px] text-[14px] ">Payment method </label>
        )}
        {cid !== 'c07d4186-75ce-41de-a770-98f74469633f' && (
          <div className="flex flex-row  justify-evenly gap-2 ">
            <button
              onClick={() => setPaymentType('ACH')}
              type="button"
              className="flex space-x-2 shadow-md shadow-gray-200 focus:ring-4 gap-1 pl-3 w-[190px] border border-gray-300  text-sm rounded-lg focus:!ring-blue-200 focus:!border-blue-500  focus:border-[1px] p-2.5 "
            >
              <div className={`${paymentType === 'ACH' ? 'h-[18px] w-[18px] border-[3px] rounded-full border-[#E2E8F0]  bg-blue-500' : 'h-[18px] w-[18px] border-[1px] rounded-full border-[#E2E8F0]  bg-white'} `} />
              <div>
                <AiFillBank className="w-fit  text-[20px] text-gray-500" />
                <span className="w-fit medium text-[13px] text-[#1a1a1ab3]">ACH</span>
              </div>
            </button>
            <button onClick={() => setPaymentType('card')} type="button" className=" flex space-x-2 shadow-md shadow-gray-200 focus:ring-4 gap-1 pl-3 w-[190px] border border-gray-300 text-gray-900 text-sm rounded-lg focus:!ring-blue-200 focus:!border-blue-500  focus:border-[1px] p-2.5 ">
              <div className={`${paymentType === 'card' ? 'h-[18px] w-[18px] border-[3px] rounded-full border-[#E2E8F0]  bg-blue-500' : 'h-[18px] w-[18px] border-[1px] rounded-full border-[#E2E8F0]  bg-white'} `}>
                {/* <span className={paymentType === 'card' ? 'w-[13px] h-[13px]  bg-blue-500' : `w-[13px] h-[13px] rounded-[25px] invisible`} /> */}
              </div>
              <div>
                <AiFillCreditCard className="w-fit text-blue-600 text-[20px] " />
                <span className="w-fit medium text-[13px] text-[#1a1a1ab3]">Credit Card</span>
              </div>
            </button>

          </div>
        )}
       
        <div className='pt-[20px]'>
          <button disabled={loading1} onClick={handlePay} type="submit" className="flex disabled:bg-gray-400 justify-center bg-[#0074d4]  w-full shadow-md shadow-gray-200 focus:ring-4 gap-1 pl-3  border border-gray-300 text-white regular text-[14px] rounded-lg focus:!ring-blue-200 focus:!border-blue-500  focus:border-[1px] p-2.5">
            {loading1 === true && (
              'Proccessing'
            )}
            {loading1 === false && (
              'Pay'
            )}
          </button>
        </div>
      </div>
      <div className='flex justify-center gap-2 items-center mt-5'>
        <span className="text-gray-400 regular self-center mt-1 text-[10px]">Powered by </span>
        <img className=" h-[14px]" src={full} alt="" />
      </div>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </div>
  );
};

export default Webpage;
